<template>
  <div class="routePlanningPanel" id="routePlanningPanel">
    <div class="top">
      <div class="basicInfo">
        <div class="photo">
          <img v-if="userInfo.iconUrl" :src="userInfo.iconUrl" />
        </div>
        <div class="info">
          <div class="row">
            <tooltip-over
              :content="'账号：' + userInfo.userNo"
              :className="'titleId'"
              class="wid190"
              refName="userNo"
            ></tooltip-over>
            <tooltip-over
              :content="'昵称：' + userInfo.username"
              :className="'right'"
              class="wid190"
              refName="username"
            ></tooltip-over>
          </div>
          <div class="row">
            <tooltip-over
              :content="'部门：' + userInfo.departmentName"
              :className="'leftContent'"
              class="wid190"
              refName="departmentName"
            ></tooltip-over>
            <tooltip-over
              :content="'区域：' + userInfo.areaName"
              :className="'right'"
              class="wid190"
              refName="areaName"
            ></tooltip-over>
          </div>
          <div class="row">
            <tooltip-over
              :content="'角色：' + userInfo.roleName"
              :className="'leftContent'"
              class="wid190"
              refName="roleName"
            ></tooltip-over>
            <tooltip-over
              :content="'站点：' + userInfo.stationName"
              :className="'right'"
              class="wid190"
              refName="stationName"
            ></tooltip-over>
          </div>
        </div>
      </div>
      <el-table
        ref="taskList"
        :data="taskList"
        height="145"
        style="width: 92%"
        :row-style="{ height: '40px' }"
        :cell-style="changeCellStyle"
        :row-class-name="tableRowClassName"
        tooltip-effect="light"
        class="taskTable"
        @row-click="clickTaskPlanRow"
      >
        <el-table-column
          prop="local_id"
          label="任务"
          align="center"
          min-width="80"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="priority"
          label="优先级"
          align="center"
          min-width="55"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.priority === 1">低</span>
            <span v-else-if="scope.row.priority === 2">中</span>
            <span v-else-if="scope.row.priority === 3">高</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="rowButton">
        <el-checkbox-group
          v-model="checkList"
          class="checkboxClass"
          @change="checkAirspaceAndWeather"
        >
          <el-checkbox v-for="menu in menuList" :label="menu.id" :key="menu.id">
            <i :class="menu.icon"> </i>{{ menu.name }}
          </el-checkbox>
        </el-checkbox-group>
        <div class="rightButtonDiv">
          <div class="buttonText" @click="queryTask">刷新</div>
          <div class="buttonText" @click="returnToTaskPlanning()">返回</div>
          <div class="buttonText" @click="logOut()">退出</div>
        </div>
      </div>
    </div>
    <div v-show="hasAirspace" class="airspace">
      <div class="title"><i class="el-icon-airspace"> </i>空域</div>
      <div class="checkBoxes">
        <div class="checkAirspaceboxClass">
          <el-checkbox
            label="1"
            v-model="forbiddenAirspace"
            @change="changeAirspace(1)"
          >
            <i class="el-icon-forbid"> </i>禁区
          </el-checkbox>
          <el-checkbox
            label="2"
            v-model="restrictAirspace"
            @change="changeAirspace(2)"
          >
            <i class="el-icon-restrict"> </i>限制区
          </el-checkbox>
          <el-checkbox
            label="3"
            v-model="earilAirspace"
            @change="changeAirspace(3)"
          >
            <i class="el-icon-erail"> </i>临时飞行区
          </el-checkbox>
          <el-checkbox
            label="4"
            v-model="cleanAirspace"
            @change="changeAirspace(4)"
          >
            <i class="el-icon-clean"> </i>净空区
          </el-checkbox>
          <el-checkbox
            label="5"
            v-model="dangerAirspace"
            @change="changeAirspace(5)"
          >
            <i class="el-icon-daiw"> </i>危险区
          </el-checkbox>
        </div>
      </div>
    </div>
    <div v-show="hasWeather" class="weather">
      <div class="title"><i class="el-icon-weather"> </i>气象</div>
      <div class="bottom">
        <el-radio-group v-model="weatherRadio" class="weatherRadio">
          <el-radio
            v-for="item in options"
            :key="item.id"
            :value="item.id"
            :label="item.id"
            >{{ item.name }}</el-radio
          >
        </el-radio-group>
        <div class="tips">
          <div class="pre">上一张</div>
          &nbsp;&nbsp;&nbsp;
          <div class="next">下一张</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import tooltipOver from "../../tools/tooltipOver";
export default {
  name: "RoutePlanningPanel",
  props: ["userInfo", "starStayPointId", "endStayPointId"],
  data() {
    return {
      taskList: [],
      checkList: [],
      menuList: [
        { id: 1, icon: "el-icon-airspace", name: "空域" },
        { id: 2, icon: "el-icon-weather", name: "气象" },
      ],
      queryTaskForm: {
        name: "",
        priority: 1,
        status: "",
        is_removed: 0,
        currentpage: 1,
        pagesize: 0,
      },
      hasAirspace: false,
      forbiddenAirspace: false,
      restrictAirspace: false,
      earilAirspace: false,
      cleanAirspace: false,
      dangerAirspace: false,
      hasWeather: false,
      weatherRadio: null,
      options: [
        {
          id: 1,
          name: "风图",
        },
        {
          id: 2,
          name: "温度图",
        },
        {
          id: 3,
          name: "降水量图 ",
        },
        {
          id: 4,
          name: "卫星云图 ",
        },
        {
          id: 5,
          name: "全国雷达拼图  ",
        },
      ],
    };
  },
  components: {
    "tooltip-over": tooltipOver,
  },
  methods: {
    showMore(val) {
      this.$confirm(val, "", {
        confirmButtonText: "好的",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        showCancelButton: false,
      });
    },
    tableRowClassName({ row, rowIndex }) {
      return "rowStyle";
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E;padding: 0;"; //修改的样式
      } else {
        return "color:#FFFFFF;padding: 0;";
      }
    },
    returnToTaskPlanning() {
      let tips = "<i class='el-icon-warn-tip'></i>返回创建计划页面?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "是的",
        cancelButtonText: "不去了",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          this.$emit("changeRoutePlanning", { show: false });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //空域、气象复选框
    checkAirspaceAndWeather() {
      let checkList = this.checkList;
      let index = checkList.findIndex((id) => {
        return id == 1;
      });
      if (index === -1) {
        this.hasAirspace = false;
      } else {
        this.hasAirspace = true;
      }
      index = checkList.findIndex((id) => {
        return id == 2;
      });
      if (index === -1) {
        this.hasWeather = false;
      } else {
        this.hasWeather = true;
      }
    },
    changeAirspace(type) {
      let show = false;
      if (1 == type) {
        show = this.$data.forbiddenAirspace;
      } else if (2 == type) {
        show = this.$data.restrictAirspace;
      } else if (3 == type) {
        show = this.$data.earilAirspace;
      } else if (4 == type) {
        show = this.$data.cleanAirspace;
      } else if (5 == type) {
        show = this.$data.dangerAirspace;
      }
      this.$emit("showAirspace", { type, show });
    }, // 查询任务
    queryTask() {
      this.$data.taskList = [];
      this.queryTaskForm.start_station_id = this.starStayPointId;
      this.queryTaskForm.end_station_id = this.endStayPointId;
      const params = this.getQueryParam(this.queryTaskForm);
      this.getRequest(
        "/uav-task-server/flight/queryFlightListByStationid.do?" + params
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.$data.taskList = data.list;
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,任务列表获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    clickTaskPlanRow(row, col, event) {
      this.$emit("requestNewAirline");
      this.getRequest(
        "/uav-task-server/flight/queryFlight.do?id=" + row.id
      ).then((res) => {
        const points = [];
        let oData = res.data;
        if (oData.code === 0) {
          oData = oData.data;
          if (oData.flight && oData.flight.task_coordinate_waypoints) {
            const waypoints = oData.flight.task_coordinate_waypoints.split(";");
            waypoints.forEach((point) => {
              const pointArr = point.split(",");
              points.push({
                lon: parseFloat(parseFloat(pointArr[1]).toFixed(6)),
                lat: parseFloat(parseFloat(pointArr[2]).toFixed(6)),
              });
            });

            this.$message({
              message: "获取航线成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          }
        } else if (oData.code != 401) {
          this.$message({
            message: "获取航线失败",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {},
          });
        }
        //发送请求航路完毕信息
        this.$emit("showNewAirline", points);
      });
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/mapCss/RoutePlanningPanel.css";
</style>



// WEBPACK FOOTER //
// src/components/home/taskplan/RoutePlanningPanel.vue